import React, { useState } from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Text } from '../../components/Typography/Typography';
import { getWeboConfig } from '../../utils';

export default () => {
  const [current, setCurrent] = useState('');
  const { t } = useTranslation();
  const history = useHistory();

  function handleClick({ key }) {
    setCurrent(key);
    if (key === 'logout') {
      axios.post('/reservations/v1/logout').then(() => {
        window.location.reload();
      });
    } else if (key === 'events') {
      history.push('/');
    } else if (key === 'home') {
      history.push(`/gift`);
    } else {
      history.push(`/${key}`);
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex' }}>
        <span style={{ position: 'absolute', paddingTop: 7, left: '3%' }}>
          <img
            width={getWeboConfig('LOGO_WIDTH') || '220px'}
            src={getWeboConfig('STORE_LOGO')}
            alt="logo"
          />
        </span>
      </div>
      <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">
        {!getWeboConfig('HIDE_EVENT') && (
          <Menu.Item key="events">
            <Text bold margin="10px 40" size="xlarge">
              {t('event')}
            </Text>
          </Menu.Item>
        )}
        {getWeboConfig('SHOW_GIFTS_V2') && (
          <Menu.Item key="home">
            <Text bold margin="10px 40" size="xlarge">
              {t('gifts')}
            </Text>
          </Menu.Item>
        )}
        {getWeboConfig('SHOW_CREATE_STUDENT_CARD') && (
          <Menu.Item key="student-card">
            <Text bold margin="10px 40" size="xlarge">
              {t('generate_student_card')}
            </Text>
          </Menu.Item>
        )}
        {getWeboConfig('SHOW_RENT') && (
          <Menu.Item key="rent">
            <Text bold margin="10px 40" size="xlarge">
              {t('rent')}
            </Text>
          </Menu.Item>
        )}
        {getWeboConfig('SG_SERVICES') && (
          <Menu.Item key="services">
            <Text bold margin="10px 40" size="xlarge">
              {t('sg_services')}
            </Text>
          </Menu.Item>
        )}
        <Menu.Item key="contact">
          <Text bold margin="10px 40" size="xlarge">
            {t('contact_us')}
          </Text>
        </Menu.Item>
        <Menu.Item key="logout">
          <Text color="#ff5959" bold margin="10px 40" size="xlarge">
            {t('logout')}
          </Text>
        </Menu.Item>
      </Menu>
    </div>
  );
};
